<main class="dashboard-layout bg-neutral">
<!--  <app-drawer></app-drawer>-->
  <section>
    <app-header/>
  </section>

  <section>
    <router-outlet></router-outlet>
  </section>

  <app-gpdr></app-gpdr>
  <section>
    <app-footer/>
  </section>

</main>
